import { Navigate, Outlet, useLocation, useOutletContext } from "react-router-dom";
import { useAuth } from "./AuthContext";
import { getRoleHomePath } from "../../helpers/getRoleHomePath";

export default function RequireRole({ allowedRoles }) {
  const { hasAnyRole, roles } = useAuth();
  const location = useLocation();
  const outletContext = useOutletContext();

  if (!hasAnyRole(allowedRoles)) {
    const redirectTo = getRoleHomePath(roles);
    if (redirectTo === location.pathname) {
      return <Navigate to="/access-denied" replace />;
    }
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet context={outletContext} />;
}
